module.exports = __webpack_public_path__ + "img/firewall.54a7614.webp";